export default __webpack_public_path__ + "assets/images/26ba1b04c9bd006b68d7cce45cd4b9bc.svg";